import { createResource, type Match, type Query } from '@atlassian/react-resource-router';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { getProjectKeyId } from '@atlassian/jira-router-resources-utils/src/utils/get-project-key-id/index.tsx';

export type ProjectIntegrationsStatus = {
	slackConnected: boolean;
	teamsConnected: boolean;
};

type ProjectSidebarAddonNavItem = {
	id: string;
	name: string;
	url?: string;
	links?: ProjectSidebarAddonNavItem[];
};

// Match on part of the ID that is consistent between prod and staging
const SLACK_PROJECT_PAGE_ID_PARTIAL =
	'com.atlassian.plugins.atlassian-connect-plugin:jira-slack-integration';
const TEAMS_PROJECT_PAGE_ID_PARTIAL = 'com.atlassian.plugins.atlassian-connect-plugin:msteams';

const getIdentifier = (match: Match, query: Query): string | undefined => {
	const { projectKey, projectId } = getProjectKeyId(match, query);
	return projectKey || projectId;
};

function getConnectedStatuses(items: ProjectSidebarAddonNavItem[]): ProjectIntegrationsStatus {
	return {
		slackConnected: items.some((i) => i.id.includes(SLACK_PROJECT_PAGE_ID_PARTIAL)),
		teamsConnected: items.some((i) => i.id.includes(TEAMS_PROJECT_PAGE_ID_PARTIAL)),
	};
}

export const softwareOnboardingGetStartedIntegrationsStatusResource =
	createResource<ProjectIntegrationsStatus | null>({
		type: 'JSW_ONBOARDING_GET_STARTED_INTEGRATIONS_STATUS_RESOURCE',
		getKey: ({ match, query }) => getIdentifier(match, query) ?? 'none',
		getData: async ({ match, query }) => {
			const projectKeyOrId = getIdentifier(match, query);
			if (projectKeyOrId == null) return null;
			const response: ProjectSidebarAddonNavItem[] = await performGetRequest(
				`/rest/navigation/4/sidebar/project/${projectKeyOrId}/addons?type=home`,
			);
			if (!response || !response.length) return { slackConnected: false, teamsConnected: false };
			return getConnectedStatuses(response);
		},
		maxAge: 0,
	});
